import React, { useEffect } from "react";
import { connect, type ConnectedProps } from "react-redux";

import SettingsForm from "../../Info/forms/SettingsForm/SettingsForm";
import Restricted from "../../../../Application/Restricted";
import { createSettingsInfoSelector } from "../../Info/forms/SettingsForm/helper";
import { fetchFlowTags } from "../../state/thunks/flowBaseThunk";
import { resetFlowBaseEntity, setNewTag } from "../../state/slices/flowBaseSlice";
import { flowBaseSelector, flowInformationSelector, getTagsOptionsSelector } from "../../state/selectors";
import { bindAction } from "../../../../../interfaces/redux";
import { type AppDispatch, type RootState } from "../../../../Application/globaltypes/redux";
import { RolePermissions } from "../../../../../enums";
import { type IWizardStep } from "../../../../../interfaces/IWizardStepsManager";
import { updateFlowTags } from "../../state/actions/infoActionCreators";
import { changeReceiveUpdatesType as changeReceiveUpdatesTypeThunk } from "../../state/thunks/flowInfoThunk";
import { FlowBaseEntities } from "../../types/flowBase";

interface OwnProps extends IWizardStep {
  isEditable: boolean;
}

export type SettingsProps = OwnProps & PropsFromRedux;

export const Settings = (props: SettingsProps) => {
  const {
    settingsInfo,
    isLoading,
    acceptHandlers,
    isOwn,
    isEditable,
    fetchTags,
    normalizedTags,
    changeReceiveUpdatesType,
    updateTags,
    setNewFlowTag,
  } = props;

  useEffect(() => {
    acceptHandlers?.({});

    return () => {
      props.resetFlowBase({ entity: FlowBaseEntities.Tags });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    isOwn && fetchTags();
  }, [isOwn, fetchTags]);

  return (
    <div className="stretch scrollable-content edit-flow-info edit-form">
      <Restricted
        permissions={[RolePermissions.FlowsCreate]}
        renderContent={(hasAnyPermission) => (
          <SettingsForm
            settingsInfo={settingsInfo}
            isDisabled={!hasAnyPermission || !isEditable}
            isLoading={isLoading}
            options={normalizedTags}
            changeReceiveUpdatesType={changeReceiveUpdatesType}
            updateTags={updateTags}
            setNewFlowTag={setNewFlowTag}
          />
        )}
      />
    </div>
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  const flowInformation = flowInformationSelector(state);
  const settingsInfo = createSettingsInfoSelector(state);
  const flowInfo = flowInformation.info;

  return {
    settingsInfo,
    isLoading: flowInformation.isLoadingInfo || Boolean(flowBaseSelector(state).loading.tags),
    isOwn: flowInfo.isOwn,
    normalizedTags: getTagsOptionsSelector(state),
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  fetchTags: bindAction(fetchFlowTags, dispatch),
  resetFlowBase: bindAction(resetFlowBaseEntity, dispatch),
  changeReceiveUpdatesType: bindAction(changeReceiveUpdatesTypeThunk, dispatch),
  updateTags: bindAction(updateFlowTags, dispatch),
  setNewFlowTag: bindAction(setNewTag, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(Settings);
export default ConnectedComponent;
